export const iconSize = {
  // Not used therefore not standardized
  tiny: 8,
  // Not used therefore not standardized
  smaller: 12,
  smallerplus: 18,
  small: 24,

  medium: 30,
  large: 56,
  // Not used therefore not standardized
  larger: 70,
  // Not used therefore not standardized
  largerPlus: 86,
  // Not used therefore not standardized
  huge: 94,
  // Not used therefore not standardized
  massive: 102,
};
